import React from "react";
import { Skeleton } from "@material-ui/lab";

const CotroliaTextareaSkeleton = () => {
  return <Skeleton height={250} style={{ borderRadius: "10px" }} />;
};

export default CotroliaTextareaSkeleton;
